import {ProductModel} from '../../../store/ProductStore'
import {useCustomerStore, useGlobalStore} from '../../../store/hooks/useStore'
import {Nullable} from '../../../types/utils'
import {ItemPrices} from '../../../types/item-prices'
import {calculateItemPrice} from './calculateItemPrice'

export function useItemPrice(hit: Nullable<ProductModel>) {
  const {selectedPriceDayOffset, selectedRegion} = useGlobalStore()
  const {getApplicablePromotions} = useCustomerStore()

  return calculateItemPrice({
    hit,
    selectedPriceDayOffset,
    selectedRegion,
    getApplicablePromotions
  })
}

export function useItemsPrices(hits: ProductModel[]): ItemPrices[] {
  const {selectedPriceDayOffset, selectedRegion} = useGlobalStore()
  const {getApplicablePromotions} = useCustomerStore()

  return hits.map((hit) => ({
    hit,
    ...calculateItemPrice({
      hit,
      selectedPriceDayOffset,
      selectedRegion,
      getApplicablePromotions
    })
  }))
}